export enum SearchyOrder {
  CREATED_AT_ASC = "created_at",
  CREATED_AT_DESC = "-created_at",
  LABEL_ASC = "label",
  LABEL_DESC = "-label",
  UPDATED_AT = "updated_at",
}
